<template>
  <div class="radiobox-wrap">
    <input ref="radiobox" class="radiobox" :class="{ active: isChecked }" type="checkbox" @click="clickRadio" />
  </div>
</template>
<script>
export default {
  emits: ['click-radio'],
  props: {
    value: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {};
  },
  methods: {
    clickRadio(e) {
      e.preventDefault();

      this.$emit('click-radio');
    }
  },
  computed: {
    isChecked() {
      if (this.value) {
        return true;
      }
      return false;
    }
  }
};
</script>
<style scoped src="@/assets/css/radiobox/radiobox.css"></style>
